import React, { useState, useRef, useEffect } from "react";

const GenericSelectTailwind = ({ 
  value, 
  onChange, 
  options = [], 
  placeholder = "Auswählen...",
  disabled = false,
  leftIcon = null,
  iconSize = "w-6 h-6"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const selectedOption = options.find(option => option.value === value);

  // Schließe Dropdown beim Klicken außerhalb
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredOptions = options.filter(option =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleOptionSelect = (option) => {
    onChange(option.value);
    setIsOpen(false);
    setSearchTerm("");
  };

  const handleToggle = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
      if (!isOpen) {
        setSearchTerm("");
      }
    }
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        type="button"
        onClick={handleToggle}
        disabled={disabled}
        className={`w-full px-3 py-2.5 text-left border rounded-md focus:ring-2 focus:ring-primary/20 dark:focus:ring-primary-light/20 focus:border-primary dark:focus:border-primary-light transition-colors ${
          disabled 
            ? 'bg-slate-50 dark:bg-slate-800 text-slate-400 dark:text-slate-500 cursor-not-allowed border-slate-200 dark:border-slate-700' 
            : 'bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600'
        }`}
      >
        <div className="flex items-center gap-2 h-5">
          {selectedOption ? (
            <>
              {leftIcon && <div className={`${iconSize} flex items-center justify-center ${iconSize.includes('w-6') ? 'flex-shrink-0' : ''}`}>{leftIcon}</div>}
              <span className="text-sm font-medium text-slate-900 dark:text-slate-100">{selectedOption.label}</span>
            </>
          ) : (
            <>
              {leftIcon && <div className={`${iconSize} flex-shrink-0`}></div>}
              <span className="text-sm text-slate-500 dark:text-slate-400">{placeholder}</span>
            </>
          )}
          <i className={`fas fa-chevron-down ml-auto text-slate-400 dark:text-slate-500 text-xs transition-transform ${isOpen ? 'rotate-180' : ''}`}></i>
        </div>
      </button>

      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md shadow-lg max-h-60 overflow-hidden">
          {options.length > 5 && (
            <div className="p-2 border-b border-slate-200 dark:border-slate-700">
              <input
                type="text"
                placeholder="Suchen..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full px-3 py-2 text-sm border border-slate-200 dark:border-slate-700 rounded-md focus:ring-2 focus:ring-primary/20 dark:focus:ring-primary-light/20 focus:border-primary dark:focus:border-primary-light bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 placeholder:text-slate-500 dark:placeholder:text-slate-400"
                autoFocus
              />
            </div>
          )}
          <div className="max-h-48 overflow-y-auto">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => handleOptionSelect(option)}
                  className="w-full px-3 py-2 text-left hover:bg-slate-50 dark:hover:bg-slate-700 focus:bg-slate-50 dark:focus:bg-slate-700 focus:outline-none transition-colors"
                >
                  <div className="flex items-center gap-2">
                    {option.icon && <span className="w-6 h-6 flex items-center justify-center">{option.icon}</span>}
                    <span className="text-sm font-medium text-slate-900 dark:text-slate-100">{option.label}</span>
                    {value === option.value && (
                      <i className="fas fa-check text-primary dark:text-primary-light ml-auto text-sm"></i>
                    )}
                  </div>
                </button>
              ))
            ) : (
              <div className="px-3 py-2 text-sm text-slate-500 dark:text-slate-400 text-center">
                Keine Optionen gefunden
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default GenericSelectTailwind;

